/** JWT expiry is a UI hint. The backend verifies the signature and session. */
export function getTokenExpiration(token: string): number | null {
  try {
    const part = token.split(".")[1];
    const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, "=")));
    return typeof payload.exp === "number" && Number.isFinite(payload.exp) ? payload.exp : null;
  } catch { return null; }
}

export function isTokenCurrent(token: string | null): boolean {
  const expires = token ? getTokenExpiration(token) : null;
  return expires !== null && expires * 1000 > Date.now();
}
